__turbopack_context__.v({
  "close": "full-screen-modal-module-scss-module__5pieVa__close",
  "coloredBg": "full-screen-modal-module-scss-module__5pieVa__coloredBg",
  "fadeIn": "full-screen-modal-module-scss-module__5pieVa__fadeIn",
  "fadeOut": "full-screen-modal-module-scss-module__5pieVa__fadeOut",
  "root": "full-screen-modal-module-scss-module__5pieVa__root",
  "root__isClosing": "full-screen-modal-module-scss-module__5pieVa__root__isClosing",
});
